import {
  ACCESSIBILITY_ARGS,
  ACTION_ARGS,
  COMPONENT_STATE_ARGS,
  FLEX_ARGS,
  POSITIONING_ARGS,
  getDefaultValueFromMetadata,
  pickArgs,
} from '../../../../utils/spds/metadata';
import { on } from '@ember/modifier';
import GhostButton from './ghost.gjs';
import Super from '../../core/base.gjs';
import styles from './close.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

const METADATA = {
  component: 'Spds::Action::Button::Close',
  description: `
Button used to perform a close action.

Extends the SPDS Core Button component.
`,
  meta: {
    ...pickArgs(ACTION_ARGS, ['close']).meta,
    ...pickArgs(COMPONENT_STATE_ARGS, ['disabled']).meta,
    ...pickArgs(FLEX_ARGS, ['alignSelf']).meta,
    ...pickArgs(POSITIONING_ARGS, ['absolute']).meta,
    ariaLabel: {
      ...ACCESSIBILITY_ARGS.meta.ariaLabel,
      defaultValue: 'close',
    },
  },
  name: 'Close Button',
  resources: {
    figma:
      'https://www.figma.com/design/g4zf0Vkj39VcCyleokv2rl/%E2%9D%96-Air-web-components?node-id=19170-11848&m=dev',
    github:
      'https://github.com/simplepractice/ember-simplepractice/tree/staging/addon/src/components/spds/action/button/close.gjs',
    zeroheight: 'https://www.simplepractice.design/1d0abbc0a/v/0/p/56566c-buttons',
  },
};

export default class SpdsActionButtonClose extends Super {
  static metadata = this.setMetadata(METADATA);
  baseClass = 'spds-action-button-close';
  styles = styles;

  get ariaLabel() {
    return (
      this.args.ariaLabel ?? getDefaultValueFromMetadata(this.constructor.metadata, 'ariaLabel')
    );
  }

  <template>
    <GhostButton
      @absolute={{@absolute}}
      @alignSelf={{@alignSelf}}
      @disabled={{@disabled}}
      @iconOnly={{true}}
      @id={{this.id}}
      aria-label={{this.ariaLabel}}
      class={{this.classes}}
      data-test-spds-action-button-close
      {{this.validateArguments}}
      {{on "click" @close}}
      ...attributes
    >
      {{svgJar "x-mark" class="spds-action-button-close-icon"}}
    </GhostButton>
  </template>
}

export const ACTION_BUTTON_CLOSE_METADATA = SpdsActionButtonClose.metadata;
